// components/MyPage/TitleSettings.jsx
import { useState, useEffect } from 'react';
import {
  Box, Typography, Button, MenuItem, Select,
  FormControl, InputLabel, Snackbar, Stack,
} from '@mui/material';
//import { useTheme } from '@mui/material/styles';
import api from '../../api/axios';
import { useUser } from '../../contexts/UserContext';
import UserNicknameWithEmoticon from '../Common/UserNicknameWithEmoticon';

export default function TitleSettings() {
  const [titles, setTitles] = useState([]);
  const [main, setMain] = useState('');
  const [sub, setSub] = useState('');
  const [prevMain, setPrevMain] = useState('');
  const [prevSub, setPrevSub] = useState('');
  const [snack, setSnack] = useState(false);
  const [tierFilter, setTierFilter] = useState('전체');

  const { userInfo, refreshUserInfo } = useUser();

  // ✅ 모바일 여부 판단
  //const theme = useTheme();
  //const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // 칭호 목록 불러오기
  useEffect(() => {
    api.get('/api/rewards/titles/mine/')
      .then(res => {
        const arr = res.data.titles || [];
        setTitles(arr);
        const m = arr.find(t => t.slot === 'main');
        const s = arr.find(t => t.slot === 'sub');
        if (m) { setMain(`${m.id}`); setPrevMain(`${m.id}`); }
        if (s) { setSub(`${s.id}`); setPrevSub(`${s.id}`); }
      })
      .catch(() => alert('칭호 목록을 불러오지 못했습니다.'));
  }, []);

  // 저장 처리
  const handleSave = async () => {
    try {
      const dupMain = sub === prevMain && sub !== '';
      const dupSub = main === prevSub && main !== '';

      if (dupMain || dupSub) {
        await api.post('/api/rewards/titles/set/', {
          main_title_id: dupSub ? null : (main || null),
          sub_title_id: dupMain ? '' : (sub || '')
        });
      }

      await api.post('/api/rewards/titles/set/', {
        main_title_id: main || null,
        sub_title_id: sub || ''
      });

      setSnack(true);
      refreshUserInfo();
      setPrevMain(main);
      setPrevSub(sub);
    } catch (e) {
      alert(e.response?.data?.message || '서버 오류');
    }
  };

  // 필터링 옵션
  const opts = (ex) => [
    <MenuItem key="" value="">(없음)</MenuItem>,
    ...titles
      .filter(t => `${t.id}` !== ex)
      .filter(t => tierFilter === '전체' || t.tier === tierFilter)
      .map(t => (
        <MenuItem key={t.id} value={`${t.id}`}>
          {t.name} ({t.tier})
        </MenuItem>
      ))
  ];

  const nameById = id => titles.find(t => `${t.id}` === id)?.name;
  const allTiers = [...new Set(titles.map(t => t.tier))];

  return (
    <Box sx={{
      mt: 4, p: 3, border: '1px solid #e0e0e0', borderRadius: 2,
      maxWidth: 400, mx: 'auto'
    }}>
      {/* ✅ 닉네임 + 필터 (모바일은 수직, PC는 수평) */}
      <Stack
        direction="row"
        flexWrap="wrap"                     // ① 넘치면 줄바꿈
        justifyContent={{ xs: 'flex-start', sm: 'space-between' }}  // ②
        alignItems="center"
        columnGap={2}
        rowGap={1}
      >
        {/* ─── 닉네임 + 칭호 ─── */}
        <UserNicknameWithEmoticon
          username={userInfo?.username}
          mainTitle={nameById(main)}
          subTitle={nameById(sub)}
          size={30}
        />

        {/* ─── 등급 필터 ─── */}
        <FormControl
          size="small"
          sx={{
            minWidth: 120,
            width: { xs: '100%', sm: 'auto' },  // 모바일: 줄바꿈 + 가로 100%
            mt: { xs: 1, sm: 0 },          // 모바일: 위 여백 8 px
          }}
        >
          <InputLabel id="tier-filter-label">등급</InputLabel>
          <Select
            labelId="tier-filter-label"
            value={tierFilter}
            label="등급"
            onChange={(e) => setTierFilter(e.target.value)}
          >
            <MenuItem value="전체">전체</MenuItem>
            {allTiers.map((t) => (
              <MenuItem key={t} value={t}>{t}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>

      <Typography variant="h6" fontWeight="bold" mt={2}>🎖️ 칭호 설정</Typography>

      <FormControl fullWidth sx={{ mt: 2 }}>
        <InputLabel id="main">대표 칭호</InputLabel>
        <Select labelId="main" value={main} label="대표 칭호"
          onChange={e => setMain(e.target.value)}>
          {opts(sub)}
        </Select>
      </FormControl>

      <FormControl fullWidth sx={{ mt: 2 }}>
        <InputLabel id="sub">서브 칭호</InputLabel>
        <Select labelId="sub" value={sub} label="서브 칭호"
          onChange={e => setSub(e.target.value)}>
          {opts(main)}
        </Select>
      </FormControl>

      <Button variant="contained" sx={{ mt: 2 }} onClick={handleSave}>저장</Button>

      <Snackbar
        open={snack} onClose={() => setSnack(false)}
        autoHideDuration={2000}
        message="칭호가 저장되었습니다."
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </Box>
  );
}
